// extracted by mini-css-extract-plugin
export default {"divider1":"Divider_divider1__uEWae","spacer":"Divider_spacer__cqvs6","mobileNone":"Divider_mobileNone__58EwT"};